import * as actions from './actions'
import { saveEntities } from '../factories'
import { sequences as route } from '../route'
import { showFeedback } from '../feedback/factories'
import { set } from 'cerebral/factories'
import { props } from 'cerebral'

export const find = [
  //
  actions.find,
  saveEntities(),
]

export const findForList = [
  //
  set(props`useRouteParams`, true),
  actions.find,
  actions.setList,
  saveEntities(),
]

export const get = [
  //
  actions.get,
  saveEntities(),
]

export const save = [
  //
  actions.save,
  actions.clearList,
  saveEntities(),
  showFeedback({ title: 'Location saved', type: 'success' }),
  route.toEventLocations,
]

export const saveWithoutFeedback = [
  //
  actions.save,
  saveEntities(),
]

export const remove = [
  //
  actions.remove,
  showFeedback({ title: 'Location deleted', type: 'success' }),
  findForList,
]
